import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import NiceSelect from '../Header/NiceSelect';
import Modal from 'react-modal';
import emailjs from '@emailjs/browser';

Modal.setAppElement('#root');

function BookATour() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const form = useRef();

  const serviceOptions = [
    { value: 'service', label: 'Select Service' },
    { value: 'Visa Assistance', label: 'Visa Assistance' },
    { value: 'Holiday Packages', label: 'Holiday Packages' },
    { value: 'Flight Booking', label: 'Flight Booking' },
    { value: 'Hotel Booking', label: 'Hotel Booking' },
    { value: 'Other Service', label: 'Other' },
  ];

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs
      .sendForm(
        'service_vistoweb',   // ✅ your EmailJS Service ID
        'template_ojenjnk',   // ✅ your EmailJS Template ID
        form.current,
        'kFqO3yj53-lKJ1q3d'  // ✅ your EmailJS Public Key
      )
      .then(
        (result) => {
          console.log('✅ Email sent successfully:', result);
          alert('Your request has been sent successfully!');
          e.target.reset();
        },
        (error) => {
          console.error('❌ Full EmailJS error:', error); // shows the full error in console
          alert(`Something went wrong: ${error.text || 'Please try again later.'}`);
        }
      )
      .finally(() => setSending(false));
  };

  return (
    <div
      className="space-extra2-top space-extra2-bottom"
      style={{
        backgroundImage: 'url(/assets/img/bg/videobg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <div className="row flex-row-reverse justify-content-center align-items-center">
          {/* Video Section */}
          <div className="col-lg-6">
            <div className="video-box1 text-center">
              <button
                className="play-btn style2 popup-video"
                onClick={() => setModalIsOpen(true)}
                aria-label="Play Tour Video"
              >
                <i className="fa-sharp fa-solid fa-play" />
              </button>
            </div>
          </div>

          {/* Form Section */}
          <div className="col-lg-6">
            <form
              ref={form}
              onSubmit={sendEmail}
              className="contact-form style2 ajax-contact"
            >
              <h3 className="sec-title mb-30 text-capitalize">Request a Service</h3>

              <div className="row">
                <div className="col-12 form-group">
                  <input
                    type="text"
                    className="form-control"
                    name="user_name"
                    placeholder="Full Name"
                    required
                  />
                  <img src="assets/img/icon/user.svg" alt="User Icon" />
                </div>

                <div className="col-12 form-group">
                  <input
                    type="email"
                    className="form-control"
                    name="user_email"
                    placeholder="Your Email"
                    required
                  />
                  <img src="assets/img/icon/mail.svg" alt="Mail Icon" />
                </div>

                <div className="form-group col-12">
                  <NiceSelect
                    name="service"
                    options={serviceOptions}
                    defaultValue="Select Service"
                  />
                </div>

                <div className="form-group col-12">
                  <textarea
                    name="message"
                    cols={30}
                    rows={3}
                    className="form-control"
                    placeholder="Your Message"
                    required
                  />
                  <img src="assets/img/icon/chat.svg" alt="Chat Icon" />
                </div>

                <div className="form-btn col-12 mt-24">
                  <button
                    type="submit"
                    className="th-btn style3"
                    disabled={sending}
                  >
                    {sending ? 'Sending...' : 'Send Message'}
                    <img src="assets/img/icon/plane.svg" alt="Send Icon" />
                  </button>
                </div>
              </div>

              <p className="form-messages mb-0 mt-3" />
            </form>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Video Popup"
        className="video-modal"
        overlayClassName="video-modal-overlay"
      >
        <button
          className="close-btn"
          onClick={() => setModalIsOpen(false)}
          aria-label="Close Video"
        >
          &times;
        </button>
        <iframe
          width="100%"
          height="400px"
          src="https://www.youtube.com/embed/cQfIUPw72Dk"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Modal>
    </div>
  );
}

export default BookATour;
